import { axios as service } from '../axiosService';
import { BASE_URL } from './index';
import { isUuid } from '@utils/common';

export const getAnalysisInsightRequest = async ({
  projectId,
  segment,
  category,
  uuid,
}) => {
  if (!projectId || !segment || !category) {
    return null;
  }

  if (isUuid(uuid)) {
    return await service.get(
      `${BASE_URL}/project/insight/${projectId}/${segment}/${uuid}?type=customizevalue`,
    );
  }

  return await service.get(
    `${BASE_URL}/project/insight/${projectId}/${segment}/${category.replace(
      /\//g,
      '_',
    )}`,
  );
};

export const getGPrinciplesAndInsightsRequest = async (
  projectId,
  companyInstance,
) => {
  if (!projectId || !companyInstance) {
    return {};
  }

  return await service.get(
    `${BASE_URL}/project/insight/${projectId}?type=${companyInstance}`,
  );
};

export const getGPrinciplesDrawerDataRequest = async (
  projectId,
  companyInstance,
) => {
  if (!projectId) {
    return {};
  }

  return await service.get(
    `${BASE_URL}/project/discussionGuide/${projectId}?type=${companyInstance}`,
  );
};

export const getOperatingModelRequest = async (projectId) => {
  if (!projectId) {
    return {};
  }

  return await service.get(`${BASE_URL}/project/operatingModel/${projectId}`);
};

export const deleteInsightRequest = async (insightId, field = 'insight') => {
  if (!insightId) {
    return {};
  }

  return await service.delete(`${BASE_URL}/project/${field}/id/${insightId}`);
};

export const postGPrinciple = async ({
  projectId,
  title,
  insight,
  summary,
  isEdit,
}) => {
  try {
    const respData = await service.post(
      `${BASE_URL}/project/guidingPrinciple/save`,
      {
        projectId,
        title,
        summary,
        guidingPrinciple: insight,
      },
    );
    return respData;
  } catch (ex) {
    throw new Error(ex);
  }
};

export const editOrAddInsight = async (data) => {
  const { urlSuffix = '', field, uuid, segment } = data;

  if (isUuid(uuid) && !data.isEdit) {
    return await service.post(
      `${BASE_URL}/project/${field}/${data.projectId}/${segment}/${uuid}?type=customizevalue`,
      {
        title: data.title,
        [field]: data[field],
        summary: data.summary,
      },
    );
  }

  if (data.isEdit && data.insightId) {
    return await service.post(
      `${BASE_URL}/project/${field}/id/${data.insightId}`,
      {
        title: data.title,
        [field]: data[field],
        summary: data.summary,
      },
    );
  }

  return await service.post(
    `${BASE_URL}/project/${field}/${data.projectId}${urlSuffix}`,
    { title: data.title, [field]: data[field], summary: data.summary },
  );
};

export const updateAllGuidingPrinciples = (
  updateBody,
  projectId,
  companyInstance,
) =>
  service.post(
    `${BASE_URL}/project/guidingPrinciple/bulkupdate/${projectId}?type=${companyInstance}`,
    updateBody,
  );

export const updateGpDrawerData = (updateBody, projectId, companyInstance) =>
  service.post(
    `${BASE_URL}/project/discussionGuide/${projectId}?type=${companyInstance}`,
    updateBody,
  );

export const deleteGpDrawerData = (id, projectId) =>
  service.delete(`${BASE_URL}/project/discussionGuide/id/${id}`);

export const updateAllOperatingModel = (updateBody, projectId) =>
  service.post(`${BASE_URL}/project/operatingModel/${projectId}`, updateBody);

export const reOrderInsights = async (projectId, type, insightsIdArr) =>
  await service.post(
    `${BASE_URL}/project/insightModule/saveDragOrder/${projectId}`,
    {
      type,
      idList: insightsIdArr,
    },
  );
export const getWaterfallChartData = async (projectId) =>
  await service.get(`${BASE_URL}/project/valueDriverWaterfall/${projectId}`);

export const getValueDriversGrid = async (projectId) => {
  try {
    const res = await service.get(
      `${BASE_URL}/project/valueDriverGrid/${projectId}`,
    );
    return res;
  } catch (ex) {
    throw new Error(ex);
  }
};

export const saveValueDriverRequest = ({ projectId, params }) =>
  service.post(`${BASE_URL}/project/valueDriver/${projectId}`, {
    valueDriverInfo: params,
  });

export const getValueDriverManageDataRequest = ({ projectId }) =>
  service.get(`${BASE_URL}/project/valueDriver/${projectId}`);

export const getMaturityAssessmentData = async (projectId) => {
  try {
    return await service.get(
      `${BASE_URL}/project/maturityAssessment/${projectId}`,
    );
  } catch (ex) {
    throw new Error(ex);
  }
};

export const saveMaturityAssessmentData = async (projectId, data) => {
  try {
    return await service.post(
      `${BASE_URL}/project/maturityAssessment/${projectId}`,
      data,
    );
  } catch (ex) {
    throw new Error(ex);
  }
};

export const getLeadingPracticeData = async (projectId) => {
  try {
    return await service.get(
      `${BASE_URL}/project/leadingPractice/${projectId}`,
    );
  } catch (ex) {
    throw new Error(ex);
  }
};

export const saveLeadingPracticeData = async (projectId, data) => {
  try {
    return await service.post(
      `${BASE_URL}/project/leadingPractice/${projectId}`,
      data,
    );
  } catch (ex) {
    throw new Error(ex);
  }
};
